module.exports = __webpack_public_path__ + "static/media/default_batch_image.38648e22.svg";